// Adapted from
// http://stackoverflow.com/questions/14012239/password-check-directive-in-angularjs/14012512#14012512

class PasswordVerifyDirective {
  constructor() {
    this.require = "ngModel"
    this.scope = {
      passwordVerify: '='
    }
  }

  link(scope, element, attrs, ctrl) {
    scope.$watch(function() {
        var combined

        if (scope.passwordVerify || ctrl.$viewValue) {
           combined = scope.passwordVerify + '_' + ctrl.$viewValue
        }
        return combined
    }, function(value) {
        if (value) {
            ctrl.$parsers.unshift(function(viewValue) {
                var origin = scope.passwordVerify
                if (origin !== viewValue) {
                    ctrl.$setValidity("passwordVerify", false)
                    return undefined
                } else {
                    ctrl.$setValidity("passwordVerify", true)
                    return viewValue
                }
            })
        }
    })
  }
}

export default PasswordVerifyDirective
